// extracted by mini-css-extract-plugin
module.exports = {"container":"Blocks_container__do32f","block":"Blocks_block___kllI"};